import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAnnonces } from "../context/AnnoncesContext";
import * as api from "../api";

const couleurs = ["#0d9488", "#6366f1", "#f59e0b", "#ec4899", "#8b5cf6", "#dc2626", "#0891b2", "#059669"];
const wilayas = ["Toutes", "Alger", "Oran", "Béjaïa", "Annaba", "Jijel", "Skikda", "Tipaza", "Mostaganem", "Chlef"];
const categoriesFilter = ["Toutes", "Yachts & Voiliers", "Bateaux à Moteur", "Équipements & Electronique", "Sports Nautiques", "Services Maritimes", "Yachts de Luxe", "Voiliers", "Divers"];

function Exposants() {
  const { annonces } = useAnnonces();
  const [exposants, setExposants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [wilaya, setWilaya] = useState("Toutes");
  const [categorie, setCategorie] = useState("Toutes");
  const [sortBy, setSortBy] = useState("annonces");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [filtersOpen, setFiltersOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Uniquement les vrais exposants — pas de fake
  useEffect(() => {
    setLoading(true);
    api.getExposants().then(res => {
      const mapped = res.data.map((u, index) => ({
        id: u.id,
        entreprise: u.entreprise || `${u.prenom} ${u.nom}`,
        nom: `${u.prenom} ${u.nom}`,
        localisation: u.wilaya || "Algérie",
        categorie: u.categorie_activite || "Divers",
        description: u.description || "Exposant professionnel sur MarinaDZ.",
        telephone: u.telephone || "—",
        email: u.email,
        siteWeb: u.site_web || null,
        nombreAnnonces: annonces.filter(a => a.exposant_id === u.id).length,
        membre: u.created_at ? new Date(u.created_at).toLocaleDateString("fr-FR") : "—",
        initiales: `${u.prenom?.[0] || ""}${u.nom?.[0] || ""}`.toUpperCase(),
        couleur: couleurs[index % couleurs.length]
      }));
      setExposants(mapped);
      setLoading(false);
    }).catch(() => { setExposants([]); setLoading(false); });
  }, []);

  const filtered = exposants.filter(e => {
    const matchSearch =
      e.entreprise.toLowerCase().includes(search.toLowerCase()) ||
      e.nom.toLowerCase().includes(search.toLowerCase()) ||
      e.localisation.toLowerCase().includes(search.toLowerCase());
    const matchWilaya = wilaya === "Toutes" || e.localisation === wilaya;
    const matchCat = categorie === "Toutes" || e.categorie === categorie;
    return matchSearch && matchWilaya && matchCat;
  }).sort((a, b) => {
    if (sortBy === "annonces") return b.nombreAnnonces - a.nombreAnnonces;
    if (sortBy === "nom") return a.entreprise.localeCompare(b.entreprise);
    return 0;
  });

  const SidebarContent = () => (
    <>
      {(wilaya !== "Toutes" || categorie !== "Toutes") && (
        <button onClick={() => { setWilaya("Toutes"); setCategorie("Toutes"); }}
          style={{ width: "100%", padding: "10px", backgroundColor: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer", marginBottom: "12px" }}>
          ✕ Réinitialiser les filtres
        </button>
      )}
      <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", marginBottom: "16px" }}>
        <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#1f2937", marginBottom: "14px" }}>Wilaya</h4>
        {wilayas.map(w => (
          <button key={w} onClick={() => setWilaya(w)} style={{ width: "100%", textAlign: "left", padding: "9px 12px", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "13px", marginBottom: "3px", backgroundColor: wilaya === w ? "#0d9488" : "transparent", color: wilaya === w ? "white" : "#374151", fontWeight: wilaya === w ? "600" : "400" }}>{w}</button>
        ))}
      </div>
      <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
        <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#1f2937", marginBottom: "14px" }}>Catégorie</h4>
        {categoriesFilter.map(c => (
          <button key={c} onClick={() => setCategorie(c)} style={{ width: "100%", textAlign: "left", padding: "9px 12px", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "12px", marginBottom: "3px", backgroundColor: categorie === c ? "#0d9488" : "transparent", color: categorie === c ? "white" : "#374151", fontWeight: categorie === c ? "600" : "400" }}>{c}</button>
        ))}
      </div>
    </>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />

      <div className="page-banner" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1920')", backgroundSize: "cover", backgroundPosition: "center", textAlign: "center", position: "relative" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.45)" }} />
        <div style={{ position: "relative" }}>
          <h1 style={{ fontSize: "42px", fontWeight: "700", color: "white", marginBottom: "12px" }}>Nos Exposants</h1>
          <p style={{ fontSize: "16px", color: "rgba(255,255,255,0.9)", marginBottom: "30px" }}>Découvrez les professionnels du secteur maritime partenaires de MarinaDZ</p>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", backgroundColor: "white", borderRadius: "12px", padding: "6px 16px", maxWidth: "500px", margin: "0 auto" }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Rechercher un exposant, une entreprise..." value={search} onChange={e => setSearch(e.target.value)} style={{ flex: 1, border: "none", outline: "none", fontSize: "15px", padding: "8px 0" }} />
          </div>
        </div>
      </div>

      <div className="exposants-main" style={{ flex: 1, backgroundColor: "#f9fafb" }}>
        <div className="exposants-inner">
          <aside className="exposants-sidebar">
            {isMobile ? (
              <div style={{ marginBottom: "16px" }}>
                <button onClick={() => setFiltersOpen(!filtersOpen)} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px", backgroundColor: "white", border: "1px solid #e5e7eb", borderRadius: "12px", cursor: "pointer", fontSize: "14px", fontWeight: "600", color: "#374151" }}>
                  <span>🔽 Filtres</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points={filtersOpen ? "18 15 12 9 6 15" : "6 9 12 15 18 9"}/></svg>
                </button>
                {filtersOpen && <div style={{ marginTop: "12px" }}><SidebarContent /></div>}
              </div>
            ) : <SidebarContent />}
          </aside>

          <section className="exposants-content">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px" }}>
              <p style={{ color: "#6b7280", fontSize: "14px" }}>
                <strong style={{ color: "#1f2937" }}>{filtered.length}</strong> exposant{filtered.length > 1 ? "s" : ""} trouvé{filtered.length > 1 ? "s" : ""}
              </p>
              <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ padding: "8px 12px", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", color: "#374151", backgroundColor: "white", cursor: "pointer", outline: "none" }}>
                  <option value="annonces">Trier : Nb annonces</option>
                  <option value="nom">Trier : Nom A-Z</option>
                </select>
                <Link to="/inscription" style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "8px 16px", borderRadius: "8px", textDecoration: "none", fontSize: "13px", fontWeight: "600" }}>
                  + Devenir Exposant
                </Link>
              </div>
            </div>

            {loading ? (
              <div style={{ textAlign: "center", padding: "60px", backgroundColor: "white", borderRadius: "14px" }}>
                <div style={{ width: "36px", height: "36px", border: "3px solid #e5e7eb", borderTop: "3px solid #0d9488", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 12px" }} />
                <p style={{ color: "#9ca3af" }}>Chargement des exposants...</p>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {filtered.length > 0 ? filtered.map(exposant => (
                  <div key={exposant.id} style={{ backgroundColor: "white", borderRadius: "14px", padding: isMobile ? "16px" : "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #f3f4f6" }}>
                    <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? "14px" : "20px" }}>

                      <div style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
                        <div style={{ width: "64px", height: "64px", borderRadius: "14px", flexShrink: 0, backgroundColor: exposant.couleur, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px", fontWeight: "700", color: "white" }}>
                          {exposant.initiales}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#1f2937", margin: "0 0 2px" }}>{exposant.entreprise}</h3>
                          <div style={{ fontSize: "13px", color: "#9ca3af", marginBottom: "8px" }}>par {exposant.nom}</div>
                          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            <span style={{ padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", backgroundColor: "#f0fdfa", color: "#0d9488" }}>{exposant.categorie}</span>
                            <span style={{ display: "flex", alignItems: "center", gap: "4px", padding: "4px 10px", borderRadius: "20px", fontSize: "11px", backgroundColor: "#f9fafb", color: "#6b7280" }}>
                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/></svg>
                              {exposant.localisation}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ fontSize: "14px", color: "#6b7280", lineHeight: "1.6", margin: "0 0 12px" }}>{exposant.description}</p>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                          <span style={{ fontSize: "13px", color: "#6b7280" }}> Membre depuis {exposant.membre}</span>
                          {exposant.telephone !== "—" && <span style={{ fontSize: "13px", color: "#6b7280" }}> {exposant.telephone}</span>}
                          {exposant.siteWeb && (
                            <a href={exposant.siteWeb.startsWith("http") ? exposant.siteWeb : `https://${exposant.siteWeb}`} target="_blank" rel="noreferrer" style={{ fontSize: "13px", color: "#0d9488", textDecoration: "none" }}>
                              🌐 {exposant.siteWeb}
                            </a>
                          )}
                        </div>
                      </div>

                      {/* ✅ Uniquement "Voir le profil" — pas de bouton contacter */}
                      <div style={{ display: "flex", alignItems: "flex-start", flexShrink: 0 }}>
                        <Link to={`/exposant/${exposant.id}`} style={{ padding: "10px 20px", backgroundColor: "#0d9488", color: "white", borderRadius: "8px", textDecoration: "none", fontSize: "13px", fontWeight: "600", textAlign: "center", whiteSpace: "nowrap", display: "block" }}>
                          Voir le profil →
                        </Link>
                      </div>
                    </div>
                  </div>
                )) : (
                  <div style={{ textAlign: "center", padding: "80px", backgroundColor: "white", borderRadius: "14px" }}>
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1" style={{ margin: "0 auto 16px", display: "block" }}>
                      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
                    </svg>
                    <p style={{ color: "#9ca3af", fontSize: "16px", marginBottom: "8px" }}>
                      {exposants.length === 0 ? "Aucun exposant inscrit pour l'instant." : "Aucun exposant trouvé."}
                    </p>
                    {exposants.length > 0 && (
                      <button onClick={() => { setSearch(""); setWilaya("Toutes"); setCategorie("Toutes"); }} style={{ padding: "10px 20px", backgroundColor: "#0d9488", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: "600" }}>
                        Réinitialiser
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
          </section>
        </div>
      </div>

      <section style={{ padding: "60px 50px", backgroundColor: "#0d9488", textAlign: "center" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "700", color: "white", marginBottom: "12px" }}>Vous êtes un professionnel du secteur maritime ?</h2>
        <p style={{ color: "rgba(255,255,255,0.9)", marginBottom: "28px", fontSize: "15px" }}>Rejoignez notre réseau d'exposants et touchez des milliers de clients potentiels.</p>
        <Link to="/inscription" style={{ backgroundColor: "white", color: "#0d9488", padding: "13px 28px", borderRadius: "8px", textDecoration: "none", fontSize: "15px", fontWeight: "700" }}>
          Devenir Exposant Gratuitement
        </Link>
      </section>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <Footer />
    </div>
  );
}

export default Exposants;